import data from './treemap.data'
import itemStyle from './treemap.itemStyle'
import label from './treemap.label'
import upperLabel from './treemap.upperLabel'
import breadcrumb from './treemap.breadcrumb'

export default {
  name: "treemap",
  nickname: "矩形树图",
  desc: "treemap",
  type: "object",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc:
        '系列名称，用于<a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip">tooltip</a>的显示，<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend">legend</a> 的图例筛选，在 <code class="codespan">setOption</code> 更新数据和配置项时用于指定对应的系列。',
    },
    data,
    itemStyle,
    label,
    upperLabel,
    breadcrumb,
    type: {
      name: "type",
      nickname: "类型",
      desc: "type",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
  },
}
